import NonJoinerStoryCard from 'routes/NonJoinerAnalytics/NonJoinerStoryCard/NonJoinerStoryCard';

export default NonJoinerStoryCard;
